import React, { useState } from 'react';
import { generateSurveyComponents } from './Util/SurveyUtil'; 
import engSurveyData from './json/Profile Survey.json';
import espSurveyData from './json/ESP Profile Survey.json'; 
import CustomButton from './Components/Buttons'; 
import { useNavigate } from 'react-router-dom';
import { collection, addDoc } from 'firebase/firestore';
import { db } from './firebase'; 
import { doc, setDoc } from 'firebase/firestore';
import { useTranslation } from 'react-i18next';
import axios from 'axios'; 
import { saveAs } from 'file-saver'; 
import ProfileOverlay from './Components/ProfileOverlay';

function SurveyPage() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [width, setWidth] = useState(window.innerWidth);
  const surveyData = i18n.language === 'es' ? espSurveyData : engSurveyData; 
  const [isLoading, setIsLoading] = useState(false);
  const [showProfileOverlay, setShowProfileOverlay] = useState(false);
  const [profileData, setProfileData] = useState(null);

  const [answers, setAnswers] = useState(() => {
    const initialAnswers = {};
    surveyData.Survey.forEach((question) => {
      if (question.Question.includes("school year: {grade}{country}")) {
        // Set default values for school year questions
        initialAnswers[`${question.Question}-Grade`] = "Kindergarten";
        initialAnswers[`${question.Question}-Country`] = "Argentina";
      } else if (question.Question.includes("{yes/no} {grade} Si es así, ¿en qué país? {country}")) {
        initialAnswers[question.Question] = {
          'yes/no': "No",
          'grade': "1st",
          'country': "Argentina"
        };
      }
       else if (question.Type === 'Dropdown' && question.dropdowns.length > 0) {
        initialAnswers[question.Question] = question.dropdowns[0].options[0];
      } else if (question.Type === 'Multiple Dropdown') {
        question.Options.forEach((_, optIndex) => {
          const dropdown = question.dropdowns?.[optIndex];
          if (dropdown?.id === 'language') {
            initialAnswers[`${question.Question}-${optIndex}`] = '';
          } else {
            initialAnswers[`${question.Question}-${optIndex}`] = dropdown?.options?.[0] || '';
          }
        });
      } else {
        initialAnswers[question.Question] = '';
      }
    });
    return initialAnswers;
  });

  const [currentCategoryIndex, setCurrentCategoryIndex] = useState(0);
  const [showValidation, setShowValidation] = useState(false); 
  const categories = [...new Set(surveyData.Survey.map((q) => q.Category))];

  const handleAnswerChange = (question, value) => {
    console.log("handleAnswerChange called with:", { question, value });
    
    setAnswers((prev) => {
      if (question === "¿Ha asistido su hijo/a a la escuela antes? {yes/no} {grade} Si es así, ¿en qué país? {country}") {
        console.log("Spanish school attendance question detected:", {
          question,
          value,
          previousValues: prev[question]
        });
        
        // Merge the new value with existing values
        return {
          ...prev,
          [question]: {
            ...prev[question], // Keep existing dropdown values
            ...value          // Update only the changed dropdown
          }
        };
      }
      
      //Other questions, just update normally
      return {
        ...prev,
        [question]: value,
      };
    });
  };



  const handleSubmit = async () => {
    /*window.scrollTo(0, 0);*/
    setIsLoading(true); 
    try {
      
      //console.log("All answers:", answers);
      const originalAnswers = Object.entries(answers).reduce((acc, [key, value]) => {
        acc[key] = value || 'N/A'; // Use 'N/A' for empty responses
        return acc;
      }, {});

      const nameQuestion = i18n.language === 'es' ? "¿Cuál es el nombre de su hijo?" : "What is your child's name???"; // Remember to change
      const name = answers[nameQuestion] || 'N/A'; //'N/A' if no answer
      const genderQuestion = i18n.language === 'es' ? "¿Cuál es el género de su hijo?" : "What is your child's gender?"; // Remember to change
      const gender = answers[genderQuestion] || 'N/A'; //'N/A' if no answer

      const docRef = doc(db, 'Responses', name); // Use name as put in the textbox as doc ID

      const surveyDocument = {
        submittedAt: new Date().toISOString(),
        Name: name,
        Language: i18n.language === 'es' ? 'ESP' : 'ENG', 
        Gender: gender,
        responses: [] // Initialize responses array
      };

      // Populate responses array with formatted questions and answers
      let position = 1;
      surveyData.Survey.forEach((question) => {
        let answerArray;

        // Check for specific questions
        if (question.Question.includes("school year: {grade}{country}") ) {
          const gradeKey = `${question.Question}-Grade`;
          const countryKey = `${question.Question}-Country`;
          const gradeAnswer = answers[gradeKey] || "Kindergarten";  // Use default if not touched
          const countryAnswer = answers[countryKey] || "Argentina";   // Use default if not touched
          
          answerArray = [
            { text: gradeAnswer },
            { text: countryAnswer }
          ];
        } else if (question.Question.includes("{yes/no} {grade} Si es así, ¿en qué país? {country}")) {
          const answer = answers[question.Question] || {};
          
          // Get values from the answer object, get default if not touched
          const yesNoAnswer = answer['yes/no'] || "No";
          const gradeAnswer = answer['grade'] || "Kindergarten";
          const countryAnswer = answer['country'] || "Argentina";
          
          answerArray = [
            { text: yesNoAnswer },
            { text: gradeAnswer },
            { text: countryAnswer }
          ];
        }
        else if (question.Question === "What is your family’s country of origin?" || question.Question ===  "¿Cuál es el país de origen de su familia?") {          
          const countryOriginAnswer = answers[question.Question] || "Argentina";   // Use default if never touched
          answerArray = [{ text: countryOriginAnswer }];
        } else {
          const answer = answers[question.Question] || 'N/A';
          answerArray = Array.isArray(answer) ? answer.map(ans => ({ text: ans })) : [{ text: answer }];
        }

        surveyDocument.responses.push({
          position: position,
          question: question.Question,
          answer: answerArray
        });
        position++;
      });
      
      //Send responses to firebase & axios
      //await setDoc(docRef, surveyDocument);
      
      await sendToAxios(surveyDocument);

      console.log('Responses submitted:', surveyDocument);
      //navigate('/survey'); // Navigate back home 


    } catch (error) {
      console.error('Error submitting survey:', error);
      alert('Failed to submit survey. Please try again.');
    }
    finally{
      setIsLoading(false); 

    }
  };
  
const sendToAxios = async (data) => {
  const url = 'https://backend-ia.dicapta.com/profile/createProfile';

  try {
    const response = await axios.post(url, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.status === 200) {
      console.log('Data sent successfully:', response.data);
      setProfileData(response.data);
      setShowProfileOverlay(true);
      
    } else {
      console.error('Failed to send data:', response);
      alert(t('responseFailSa'));
    }
  } catch (error) {
    console.error('Error sending data to backend:', error);
    alert(t('responseFailSe'));
  }
};

  const handleNextCategory = () => {
    window.scrollTo(0, 0);
    const currentCategoryQuestions = surveyData.Survey.filter(
      (q) => q.Category === categories[currentCategoryIndex]
    );
    const allAnswered = currentCategoryQuestions.every((question) => {
      const answer = answers[question.Question];
      return answer !== ''
    });

    if (!allAnswered) {
      setShowValidation(true); // Show unanswered questions
      alert(t('pleaseRespond'));
      return;
    }

    setShowValidation(false); // Reset validation
    if (currentCategoryIndex < categories.length - 1) {
      setCurrentCategoryIndex(currentCategoryIndex + 1);
    }
  };

  const handlePreviousCategory = () => {
    window.scrollTo(0, 0);
    if (currentCategoryIndex > 0) {
      setCurrentCategoryIndex(currentCategoryIndex - 1);
    }
  };

  return (
    <div style={{ padding: '0', width: '100%' }}>
      <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', marginTop: '10px',color: 'var(--primary-color)', borderBottom: '3px solid var(--primary-color)' }}>
        <h2 style={{ textAlign: 'center', /*marginTop: 150, marginLeft: width / 15,*/ marginBottom: '5px', fontFamily: 'KomikaAxis' }}>
          {categories[currentCategoryIndex]}
        </h2>
        <h2 style={{ textAlign: 'right', /*marginTop: 150, marginRight: width / 15,*/ marginBottom: '5px' }}>
          {`${currentCategoryIndex + 1} / ${categories.length}`}
        </h2>
      </div>
      {isLoading && (
        <div style={{ 
          fontFamily: 'KomikaAxis', 
          color: 'var(--primary-color)',
          textAlign: 'center',
          padding: '10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '10px'
        }}>
          <div className="loading-spinner" style={{
            width: '20px',
            height: '20px',
            border: '3px solid var(--primary-color)',
            borderTop: '3px solid transparent',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }} />
          {t('pleaseWait')}
        </div>
      )}
      <div
        style={{
          backgroundColor: 'var(--primary-white-color)',
          borderRadius: '15px',
          padding: '20px',
          width: '80%',
          margin: '10px auto',
          minHeight: '300px',
          boxSizing: 'border-box',
        }}
      >
        {generateSurveyComponents(
          surveyData,
          handleAnswerChange,
          answers,
          categories[currentCategoryIndex],
          t,
          i18n,
          showValidation
        )}
      </div>
  
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
        {currentCategoryIndex > 0 && (
          <div style={{ textAlign: 'center', marginRight: '10px' }}>
            <CustomButton
              label={t('buttonPrevious')}
              type="back"
              onClick={handlePreviousCategory}
            />
          </div>
        )}
  
        {currentCategoryIndex !== categories.length - 1 && (
          <div style={{ textAlign: 'center', marginRight: '10px' }}>
            <CustomButton
              label={t('buttonNext')}
              type="next"
              onClick={handleNextCategory}
            />
          </div>
        )}
  
        {currentCategoryIndex === categories.length - 1 && (
          <div style={{ textAlign: 'center' }}>
            <CustomButton
              label={isLoading ? t('sending') : t('buttonSubmit')}
              type="primary"
              onClick={handleSubmit}
              disabled={isLoading}
              style={{
                opacity: isLoading ? 0.7 : 1,
                cursor: isLoading ? 'not-allowed' : 'pointer'
              }}
            />
          </div>
        )}
      </div>
      
      {showProfileOverlay && (
        <ProfileOverlay 
          profile={profileData}
          onClose={() => {
            setShowProfileOverlay(false);
            navigate('/start');
          }}
        />
      )}
    </div>
  );
  
}

export default SurveyPage;
